export default __webpack_public_path__ + "static/media/trash.2595a7fc.svg";